<template>
  <BSelectWithValidation
    v-if="visible"
    :id="`prelimInput_${field.identifier}`"
    rules="required"
    :label="field.label"
    v-model="selectedValue"
  >
    <option
      v-for="(iv, index) in field.inputValues"
      :id="`prelimInput_${field.identifier}_${index}`"
      :value="iv.value"
      :key="index"
    >
      {{ iv.text }}
    </option>
  </BSelectWithValidation>
</template>

<script>
export default {
  name: "PreliminarySelectQuestion",
  components: {
    BSelectWithValidation: () =>
      import("@/components/BSelectWithValidation.vue"),
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedValue: null,
    };
  },
  mounted() {
    this.selectedValue =
      this.$store.getters["preliminaryAssessment/answer"](
        this.field.identifier
      ) || null;
    this.$watch("selectedValue", this.valueWatcher);
  },
  methods: {
    valueWatcher() {
      this.$store.dispatch("preliminaryAssessment/addData", {
        question: this.field.identifier,
        answer: this.selectedValue,
      });
    },
  },
};
</script>

<style scoped></style>
